import { FC } from 'react';
import { useSelector } from 'react-redux';

import RichTextRenderer from '@/components/rich-text-renderer';
import { logout, register } from '@/lib/auth';
import useVariables from '@/lib/hooks/use-variables';
import { selectGlobalPageTheme } from '@/store/slices/global';
import { selectIsUserLoggedIn } from '@/store/slices/user';

import LoginButton from '../login-button';
import styles from './styles';

const AuthButtons: FC = () => {
  const variables = useVariables();
  const isUserLoggedIn = useSelector(selectIsUserLoggedIn);
  const pageTheme = useSelector(selectGlobalPageTheme);

  const loginButtonClassName =
    pageTheme === 'esn'
      ? 'tesn:bg-esn-secondary-light hover:tesn:bg-esn-secondary-superLight tesn:text-white'
      : '';

  return (
    <div className={styles.authButtons}>
      <LoginButton loginButtonClassName={loginButtonClassName} />

      <span className="ml-2">oder</span>

      {isUserLoggedIn ? (
        <button className={styles.underlinedButton} onClick={logout}>
          {<RichTextRenderer body={variables['nav-logout-button']} />}
        </button>
      ) : (
        <button className={styles.underlinedButton} onClick={register}>
          {<RichTextRenderer body={variables['nav-register-button']} />}
        </button>
      )}
    </div>
  );
};

export default AuthButtons;
